import { getCookie } from '@/utils/utils'
export const filterOptions = {
  dateOptions: [
    {
      label: window.$t('system::time::text::data_all'),
      value: 'data-all'
    },
    {
      label: window.$t('system::time::text::today'),
      value: 'data-today'
    },
    {
      label: window.$t('system::time::text::yestoday'),
      value: 'data-yestoday'
    },
    {
      label: window.$t('system::time::text::data_monthDate_yestoday'),
      value: 'data-monthDate-yestoday'
    },
    {
      label: window.$t('system::time::text::data_monthDate_today'),
      value: 'data-monthDate-today'
    },
    {
      label: window.$t('system::time::text::data_frontday'),
      value: 'data-frontday'
    },
    {
      label: window.$t('system::time::text::data_recentday'),
      value: 'data-recentday'
    },
    {
      label: window.$t('system::time::text::data_ecentday_notoday'),
      value: 'data-recentday-notoday'
    },
    // {
    //     label: "最近3天",
    //     value: "data-3day"
    // },
    // {
    //     label: "最近7天",
    //     value: "data-7day"
    // },
    // {
    //     label: "最近30天",
    //     value: "data-30day"
    // },
    // {
    //     label: "最近90天",
    //     value: "data-90day"
    // },
    {
      label: window.$t('system::time::text::data_auto'),
      value: 'data-auto'
    }
  ], // 日期类别大全
  stringOptions: [
    {
      label: window.$t('system::time::category::data_all'),
      value: 'data-all'
    },
    {
      label: window.$t('system::time::category::data_in'),
      value: 'data-in'
    },
    {
      label: window.$t('system::time::category::data_not_in'),
      value: 'data-not-in'
    }
  ], // 字符串类别大全
  numOptions: [
    {
      label: window.$t('system::report_option::data_all'),
      value: 'data-all'
    },
    {
      label: window.$t('system::report_option::data_large'),
      value: 'data-large'
    },
    {
      label: window.$t('system::report_option::data_large_equal'),
      value: 'data-large-equal'
    },
    {
      label: window.$t('system::report_option::data_less'),
      value: 'data-less'
    },
    {
      label: window.$t('system::report_option::data_less_equal'),
      value: 'data-less-equal'
    },
    {
      label: window.$t('system::report_option::data_equal'),
      value: 'data-equal'
    },
    {
      label: window.$t('system::report_option::data_not_equal'),
      value: 'data-not-equal'
    },
    {
      label: window.$t('system::report_option::data_area'),
      value: 'data-area'
    }
  ] //数值类别大全
};

// 数值标识箭头
export const arrowOptions = [
  { value: 'arrowup', color: '#3388FF' },
  { value: 'arrowdown', color: '#F2637B' },
  { value: 'horizontal', color: '#323233' },
  { value: 'default', color: '#7C7C7C' }
];

// 数值标识颜色
export const fontColorOptions = [
  { value: 'rgb(0, 172, 193)', color: '绿色', smallColor: 'rgb(0, 172, 193)' },
  { value: '#F2637B', color: '红色', smallColor: 'rgba(242,99,123,0.6)' },
  { value: '#323333', color: '黑色', smallColor: '#323233' }
];

// 数值报警大全
export const numConditionOptions = [
  {
    label: window.$t('system::report_option::data_large'),
    value: 'LARGE'
  },
  {
    label: window.$t('system::report_option::data_less'),
    value: 'LESS'
  },
  {
    label: window.$t('system::report_option::data_equal'),
    value: 'EQUAL'
  },
  {
    label: window.$t('system::report_option::data_area'),
    text: 'data_area',
    value: 'AREA'
  }
];
// 报表功能大全
export const reportFunctionList = [
  {
    key: 'download',
    chinese: window.$t('system::function::download')
  },
  {
    key: 'edit',
    chinese: window.$t('system::function::edit')
  },
  {
    key: 'delete',
    chinese: window.$t('system::function::delete')
  }
];
// 共存column判断
export const colunmnCoexist = [
  {
    tableWithDimensions: {
      '8b33c6c8-cf82-4b0e-bad4-50d551e5680f': 'rdt_ad_stat_age',
      '87b062b2-c211-425f-b026-97edd97297f9': 'rdt_ad_stat_country',
      '40e41417-f2d5-45f8-af32-b8fba07b0c39': 'rdt_ad_stat_flexible',
      '4f2f94d2-4cc1-45cc-a0f5-a0b3a1ca48f0': 'rdt_ad_stat_flexible',
      'd091a2d9-d0f7-4c14-8f30-aba80dffafb4': 'rdt_ad_stat_flexible',
      '7018c9bb-5c20-4951-b04d-f836e718874d': 'rdt_ad_stat_gender',
      'dc7583a3-ae3a-4090-99fc-a9a9851b5aa6': 'rdt_ad_stat_impression_device',
      '9401bd8d-35bf-4f71-bbc0-62adba170d39': 'rdt_ad_stat_platform_position',
      '13cb1d37-3e2c-4f29-920d-a2fbfd4d5b07': 'rdt_ad_stat_platform_position',
      '7ab633ab-c8bc-4411-a278-b67fcb2a66c7': 'rdt_ad_stat_hours'
    },
    tableWithMeasures: {
      'a22339b0-d2c7-4889-8a12-1f145362554d': 'rdt_ad_stat_flexible'
    }
  }
];



export const guidanceConfig = ($t) => {
  return {
    '2': [
      {
        title: `1.${$t('stores::store::shopify_one')}`,
        text: $t('stores::store::shopify_one_text'),
        url: langEnv() ? require('../assets/images/userGuidance/shopify-one.png') :
          require('../assets/images/userGuidance/shopify-one.png')
      },
      {
        title: `2.${$t('stores::store::shopify_two')}`,
        text: '',
        url: langEnv() ? require('../assets/images/userGuidance/shopify-two.png') :
          require('../assets/images/userGuidance/shopify-two-en.png')
      },
      {
        title: `3.${$t('stores::store::shopify_three_2')}`,
        text: '',
        url: langEnv() ? require('../assets/images/userGuidance/shopify-three-2-cn.png') :
          require('../assets/images/userGuidance/shopify-three-2.png')
      },
      {
        title: `4.${$t('stores::store::shopify_three')}`,
        text: '',
        url: langEnv() ? require('../assets/images/userGuidance/shopify-three.png') :
          require('../assets/images/userGuidance/shopify-three-en.png')
      },
      {
        title: `5.${$t('stores::store::shopify_four')}`,
        text: '',
        url: langEnv() ? require('../assets/images/userGuidance/shopify-four.png') :
          require('../assets/images/userGuidance/shopify-four-en.png')
      }
    ],
    '3': [
      {
        title: `1.${$t('stores::store::shopplazza_one')}`,
        text: $t('stores::store::shopplazza_one_text'),
        url: langEnv() ? require('../assets/images/userGuidance/shoplazza-one.png') :
          require('../assets/images/userGuidance/shoplazza-one.png')
      },
      {
        title: `2.${$t('stores::store::shopplazza_two')}`,
        text: '',
        url: langEnv() ? require('../assets/images/userGuidance/shoplazza-two.png') :
          require('../assets/images/userGuidance/shoplazza-two-en.png')
      },
      {
        title: `3.${$t('stores::store::shopplazza_three')}`,
        text: '',
        url: langEnv() ? require('../assets/images/userGuidance/shoplazza-three.png') :
          require('../assets/images/userGuidance/shoplazza-three-en.png')
      },
      {
        title: `4.${$t('stores::store::shopplazza_four')}`,
        text: '',
        url: ''
      }
    ],
    '4': [
      {
        title: `1.${$t('stores::store::shopline_one')}`,
        text: $t('stores::store::shopline_one_text'),
        url: langEnv() ? require('../assets/images/userGuidance/shopline-one.png') :
          require('../assets/images/userGuidance/shopline-one-en.png')
      },
      {
        title: `2.${$t('stores::store::shopline_two')}`,
        text: '',
        url: langEnv() ? require('../assets/images/userGuidance/shopline-two.png') :
          require('../assets/images/userGuidance/shopline-two-en.png')
      },
      {
        title: `3.${$t('stores::store::shopline_three')}`,
        text: '',
        url: langEnv() ? require('../assets/images/userGuidance/shopline-three.png') :
          require('../assets/images/userGuidance/shopline-three-en.png')
      }
    ],
    '5': [
      {
        title: `1.${$t('stores::store::shopbase_one')}`,
        text: $t('stores::store::shopbase_one_text'),
        url: require('../assets/images/userGuidance/shopbase-one.png')
      },
      {
        title: `2.${$t('stores::store::shopbase_two')}`,
        text: '',
        url: langEnv() ? require('../assets/images/userGuidance/shopbase-two.png') :
          require('../assets/images/userGuidance/shopbase-two-en.png')
      },
      {
        title: `3.${$t('stores::store::shopbase_three')}`,
        text: '',
        url: langEnv() ? require('../assets/images/userGuidance/shopbase-three.png') :
          require('../assets/images/userGuidance/shopbase-three-en.png')
      },
      {
        title: `4.${$t('stores::store::shopbase_four')}`,
        text: '',
        url: langEnv() ? require('../assets/images/userGuidance/shopbase-four.png') :
          require('../assets/images/userGuidance/shopbase-four-en.png')
      },
      {
        title: `5.${$t('stores::store::shopbase_five')}`,
        text: '',
        url: langEnv() ? require('../assets/images/userGuidance/shopbase-five.png') :
          require('../assets/images/userGuidance/shopbase-five-en.png')
      },
    ]
    // '1': [
    //   {
    //     title: '1.登录您的Shoplus账户',
    //     text:
    //       '链接：<a target="view_frame" href="https://login.shoplus.net/userLogin/">https://login.shoplus.net/userLogin/</a>',
    //     url: require('../assets/images/userGuidance/shoplus-one.png')
    //   },
    //   {
    //     title: '2.点击菜单【设置】,进入【应用管理】',
    //     text: '',
    //     url: require('../assets/images/userGuidance/shoplus-two.png')
    //   },
    //   {
    //     title: '3.创建新的应用，将应用API key 等信息填写在右侧窗口；',
    //     text: '',
    //     url: ''
    //   }
    // ]
  }
}
export const langEnv = () => {
  // 判断时候中文环境
  return getCookie('language') !== 'en'
}

// 数据报表跳转配置
export const reportJumpUrl = () => {
  function getUrl(folderID, boardID, reportID) {
    return `/edit-report?folderID=${folderID}&boardID=${boardID}&reportID=${reportID}&isPerson=true&jump=true`
  }
  if (process.env.VUE_APP_ENV === 'prod' || process.env.VUE_APP_ENV === 'uat') {
    return {
      // 正式
      // 销售报表
      salesReport: getUrl(3, 3, 201),
      // 广告分析
      adAnalysis: getUrl(3, 3, 202),
      // 履约概览
      performAnalysis: getUrl(3, 3, 203),
      // 退款概览
      refundAnalysis: getUrl(3, 3, 204),
      // 工单概览
      workOrderAnalysis: getUrl(3, 3, 205)
    }
  } else {
    return {
      // 测试
      // 销售报表
      salesReport: getUrl(40, 3, 201),
      // 广告分析
      adAnalysis: getUrl(40, 3, 202),
      // 履约概览
      performAnalysis: getUrl(40, 3, 203),
      // 退款概览
      refundAnalysis: getUrl(40, 3, 204),
      // 工单概览
      workOrderAnalysis: getUrl(40, 3, 205)
    }
  }
}
